import React from 'react';
import { Container } from '@material-ui/core';

import { appStyles } from '../_styles';

/**
 * ACTMT standard container for page layout.
 * TODO: Test
 * @param {object} prop React property object.
 * React Component (https://reactjs.org/docs/react-component.html)
 */
const AmContainerLeft = (prop: any) => {
  // Hook to create classes used to style the input container.
  const classes = appStyles();

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paperLeft}>{prop.children}</div>
    </Container>
  );
};

export { AmContainerLeft };
